module.exports = __webpack_public_path__ + "static/media/icon-settings.a7654f91.svg";